import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  endTestTimer,
  getTestQuestions,
  insertTestData,
  questionSaveAndNext,
  questionSaveAndNextEval,
} from "../../redux/test/actions";

const useMCQTest = () => {
  const [state, setState] = useState({
    current: 0,
    index: 1,
    selectedAns: {},
    correctAns: {},
    isNotAnswered: false,
    isSave: false,
    isSubmit: false,
  });
  const testQuestions = useSelector((state) => state.test.testQuestions?.data);
  const totalTimeEnd = useSelector((state) => state.test.testTime?.endExam);
  const totalTime = useSelector((state) => state.test.testTime?.data);
  const totalQuestion = useSelector(
    (state) => state.test.questionSummary?.totalQuestion
  );
  const current = useSelector((state) => state.test.questionSummary?.current);
  const index = useSelector((state) => state.test.questionSummary?.index);
  const questionsInfoSummary = useSelector(
    (state) => state.test.questionSummary?.questionsInfo
  );
  const submittedAnswers = useSelector((state) => state.test.submitAnswer);
  const testInfoPtr = useSelector((state) => state.test.testInfoPtr);
  const testDetails = useSelector((state) => state.test.testDetails?.data);
  const user = useSelector((state) => state.auth.user.data);

  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const examMode = searchParams.get("exam-mode");
  const navigate = useNavigate();

  const handleOptionSelect = (e, id, val) => {
    setState((state) => ({
      ...state,
      selectedAns: { ...state.selectedAns, [id]: e },
      correctAns:
        examMode === "false" || !examMode
          ? { ...state.correctAns, [id]: val }
          : {},
    }));
  };

  const handleChange = (num, id) => {
    let questionsInfo = questionsInfoSummary?.map((obj) =>
      obj.id === id && !obj.status
        ? { ...obj, status: "notAnswered", submittedAns: null }
        : { ...obj }
    );

    dispatch(
      questionSaveAndNext({
        questionsInfo,
        current: num - 1,
        index: num,
      })
    );
  };

  const saveAndMarkHandler = (num, id) => {
    if (state.selectedAns[id]) {
      let current = totalQuestion === num + 1 ? num : num + 1;
      let index = totalQuestion === current ? current : current + 1;
      let questionsInfo = questionsInfoSummary?.map((obj) =>
        obj.id === id
          ? {
              ...obj,
              status: "saveAndMark",
              submittedAns: state.selectedAns[id],
            }
          : {
              ...obj,
            }
      );
      if (examMode === "true") {
        let submitArray = Array.from({ length: 5 }, () => null);

        // Set the selected option at the appropriate index
        if (state.selectedAns[id] >= 1 && state.selectedAns[id] <= 5) {
          submitArray[state.selectedAns[id] - 1] = state.selectedAns[id];
        }
        let arr = submittedAnswers?.map((x, i) => {
          if (num === i) {
            return {
              SubmittedAnswer: submitArray,
              TestQuestionsPtr: {
                __type: "Pointer",
                className: "test_TestQuestions",
                objectId: questionsInfo[i]?.id,
              },
              CorrectAnswer: [questionsInfo[i]?.correctAns],
              ObtainedMarks:
                questionsInfo[i]?.correctAns === state.selectedAns[id]
                  ? questionsInfo[i]?.marks
                  : questionsInfo[i]?.negativeMarks > 0
                  ? -questionsInfo[i]?.negativeMarks
                  : 0,
            };
          } else {
            return x;
          }
        });
        dispatch(
          questionSaveAndNextEval({ questionsInfo, current, index, arr })
        );
      } else {
        dispatch(questionSaveAndNext({ questionsInfo, current, index }));
      }
    } else {
      setState((state) => ({ ...state, isNotAnswered: true }));
    }
  };

  const saveAndNextHandler = (num, id) => {
    if (state.selectedAns[id]) {
      let current = totalQuestion === num + 1 ? num : num + 1;
      let index = totalQuestion === current ? current : current + 1;
      let questionsInfo = questionsInfoSummary?.map((obj) =>
        obj.id === id
          ? {
              ...obj,
              status: "answered",
              submittedAns: state.selectedAns[id],
            }
          : { ...obj }
      );
      if (examMode === "true") {
        let submitArray = Array.from({ length: 5 }, () => null);

        // Set the selected option at the appropriate index
        if (state.selectedAns[id] >= 1 && state.selectedAns[id] <= 5) {
          submitArray[state.selectedAns[id] - 1] = state.selectedAns[id];
        }
        let arr = submittedAnswers?.map((x, i) => {
          if (num === i) {
            return {
              SubmittedAnswer: submitArray,
              TestQuestionsPtr: {
                __type: "Pointer",
                className: "test_TestQuestions",
                objectId: questionsInfo[i]?.id,
              },
              CorrectAnswer: [questionsInfo[i]?.correctAns],
              ObtainedMarks:
                questionsInfo[i]?.correctAns === state.selectedAns[id]
                  ? questionsInfo[i]?.marks
                  : questionsInfo[i]?.negativeMarks > 0
                  ? -questionsInfo[i]?.negativeMarks
                  : 0,
            };
          } else {
            return x;
          }
        });
        dispatch(
          questionSaveAndNextEval({ questionsInfo, current, index, arr })
        );
      } else {
        dispatch(questionSaveAndNext({ questionsInfo, current, index }));
      }
    } else {
      setState((state) => ({ ...state, isNotAnswered: true }));
    }
  };

  const clearHandler = (id, current) => {
    let questionsInfo = questionsInfoSummary?.map((obj) =>
      obj.id === id
        ? {
            ...obj,
            status: "notAnswered",
            submittedAns: null,
          }
        : { ...obj }
    );
    dispatch(
      questionSaveAndNext({ questionsInfo, current, index: current + 1 })
    );
    setState((state) => ({
      ...state,
      selectedAns: { ...state.selectedAns, [id]: null },
    }));
  };

  const nextHandler = (num, id) => {
    let current = totalQuestion === num + 1 ? num : num + 1;
    let index = totalQuestion === current ? current : current + 1;
    let questionsInfo = questionsInfoSummary?.map((obj) =>
      obj.id === id && !obj.status
        ? {
            ...obj,
            status: "notAnswered",
            submittedAns: null,
          }
        : {
            ...obj,
          }
    );
    dispatch(questionSaveAndNext({ questionsInfo, current, index }));
  };

  const previousHandler = (num) => {
    dispatch(
      questionSaveAndNext({
        questionsInfo: questionsInfoSummary,
        current: num - 1,
        index: num,
      })
    );
  };

  const markForReviewHandler = (num, id) => {
    let current = totalQuestion === num + 1 ? num : num + 1;
    let index = totalQuestion === current ? current : current + 1;
    let questionsInfo = questionsInfoSummary?.map((obj) =>
      obj.id === id
        ? {
            ...obj,
            status: "markedForReview",
          }
        : { ...obj }
    );

    dispatch(questionSaveAndNext({ questionsInfo, current, index }));
  };

  const handleSubmit = () => {
    setState((state) => ({ ...state, isSave: true }));
  };

  const onClose = () => {
    setState((state) => ({ ...state, isSave: false }));
  };
  const closeModal = () => {
    if (examMode === "false") {
      setState((state) => ({ ...state, isSave: false, isSubmit: true }));
    } else {
      const totalMarks = testInfoPtr?.TotalMarks;

      const obtainedMarks = submittedAnswers.reduce((total, question) => {
        if (question) {
          return total + question.ObtainedMarks;
        } else {
          return total;
        }
      }, 0);
      const percentage = (obtainedMarks / totalMarks) * 100;
      const payload = {
        testPtr: testDetails?.objectId,
        customerPtr: user.objectId,
        testDataList: submittedAnswers,
        CourseTitle: testDetails?.CourseTitle,
        TestTitle: testDetails?.TestTitle,
        percentage,
        obtainedMarks,
        totalMarks,
        Status: testDetails?.Status,
        custMobNo: user?.Mob_no,
        custName: user?.First_name,
      };
      dispatch(insertTestData(payload));
    }
    dispatch(endTestTimer());
  };

  const doneHandler = () => {
    setState((state) => ({ ...state, isSubmit: false }));
    navigate("/home");
  };

  useEffect(() => {
    if (id) {
      dispatch(getTestQuestions(id));
    }
  }, []);

  useEffect(() => {
    if (state.isNotAnswered) {
      setTimeout(() => {
        setState((state) => ({ ...state, isNotAnswered: false }));
      }, 5000);
    }
  }, [state.isNotAnswered]);

  useEffect(() => {
    if (totalTimeEnd) {
      setState((state) => ({ ...state, isSave: false, isSubmit: true }));
    }
  }, [totalTimeEnd]);

  useEffect(() => {
    if (!totalTime) {
      if (totalTimeEnd) {
      } else {
        navigate("/home");
      }
    }
  }, [totalTime]);

  return {
    testQuestions,
    state,
    examMode,
    totalQuestion,
    questionsInfoSummary,
    current,
    index,
    handleChange,
    nextHandler,
    markForReviewHandler,
    previousHandler,
    handleOptionSelect,
    saveAndNextHandler,
    clearHandler,
    saveAndMarkHandler,
    handleSubmit,
    closeModal,
    doneHandler,
    onClose,
  };
};

export default useMCQTest;
